/** Backend sanitizes filenames (e.g. spaces→underscores). Use for comparing attachment names. */
export const normalizeFileName = (name: string) => name.replace(/\s+/g, "_");

export const ALLOWED_ATTACHMENT_EXTENSIONS = [".docx", ".pdf", ".html", ".md", ".txt", ".xlsx", ".pptx", ".png", ".jpg", ".jpeg"] as const;

/** Human-readable list of accepted extensions for error messaging. */
export const ALLOWED_ATTACHMENT_EXTENSIONS_LABEL = ALLOWED_ATTACHMENT_EXTENSIONS.join(", ");

export const getFileExtension = (name: string) =>
  "." + (name.split(".").pop()?.toLowerCase() ?? "");

export const isAllowedAttachmentExtension = (name: string) =>
  (ALLOWED_ATTACHMENT_EXTENSIONS as readonly string[]).includes(getFileExtension(name));

/** Reads a File and resolves the base64 payload, stripping the `data:...;base64,` prefix. */
export const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(",")[1]);
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
